<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem>展商</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">展商列表</div>
        <Input search placeholder="请输入关键字" v-model="search" @on-search="searchPro" style="width:230px;margin-top:20px;" />
        <!-- <div class="header-tool-utils">
          批量操作：
          <Poptip confirm title="确认批量显示?" @on-ok="setAllShow">
            <Button type="primary" ghost>显示</Button>
          </Poptip>
          <Poptip confirm title="确认批量隐藏?" @on-ok="setAllHide">
            <Button type="primary" ghost>隐藏</Button>
          </Poptip>
          <Poptip confirm title="确认批量删除?" @on-ok="setAllDel">
            <Button type="primary" ghost>删除</Button>
          </Poptip>
          <Poptip confirm title="确认批量发送短信?" @on-ok="ok">
            <Button type="primary" ghost>短信</Button>
          </Poptip>
        </div> -->
      </div>
      <div class="header-tool-box">
        <!-- <div class="htb-item" @click="ok">
          <span class="htb-add">+</span>
          <span>导入展商</span>
        </div>-->

        <Poptip confirm title="确认是否批量同步会刊信息?" @on-ok="syncHandle" placement="bottom">
          <div class="htb-item">
            <span class="htb-add">+</span>
            <span>批量同步</span>
          </div>
        </Poptip>
        <!-- <div class="htb-item" @click="$router.push('/host/index/ex/addEx')">
          <span class="htb-add">+</span>
          <span>添加展商</span>
        </div>
        <div class="htb-item" @click="$router.push('/host/index/ex/export-info')">
          <span>导出报告</span>
        </div> -->

      </div>
    </div>
    <div class="layout-content" style="background: transparent;">
      <div v-if="list.length">
        <Table ref="selection" :columns="columns" :data="list" @on-selection-change="changeEvent">
          <template slot-scope="{ row }" slot="logo">
            <img :src="row.logo" v-if="row.logo" class="logo" />
            <img src="@/assets/img/empty.png" v-else class="logo" />
          </template>

          <template slot-scope="{ row }" slot="name">{{row.name}}</template>
          <template slot-scope="{ row }" slot="prizeLabel">{{row.prizeLabel || '无'}}</template>
          <template slot-scope="{ row }" slot="exOperator">{{row.exOperator}}</template>
          <template slot-scope="{ row }" slot="categories">
            <template v-if="row.categories">
              <!-- {{row.categories}} -->
              <span v-for="(item, index) in row.categories" :key="'categories-' + Math.random()  + index">
                <span v-if="Object.prototype.toString.call(item) === '[object Object]'">
                  {{item.Name}}
                  <span v-if="item.List && item.List.length && item.List[0].Name">
                    {{' > ' + item.List[0].Name }}
                    <span v-if="item.List[0].List && item.List[0].List.length && item.List[0].List[0].Name">{{' >' + item.List[0].List[0].Name }}</span>
                  </span>
                </span>
                <span v-else>{{item}}</span>
              </span>
            </template>
            <template v-else></template>
          </template>

          <template slot-scope="{ row }" slot="address">
            <!-- boothInfo为对象 -->
            <span v-if="row.boothInfo && row.boothInfo.length && Object.prototype.toString.call(row.boothInfo) === '[object Object]'">
              <span v-if="row.boothInfo.Hall">{{row.boothInfo.Hall}}</span>
              <span v-if="row.boothInfo.Code">{{row.boothInfo.Code}}</span>
            </span>
            <!-- boothInfo为数组 -->
            <span v-else-if="row.boothInfo && row.boothInfo.length && Object.prototype.toString.call(row.boothInfo) === '[object Array]'">
              <span v-if="row.boothInfo[0].Hall">{{row.boothInfo[0].Hall}}</span>
              <span v-if="row.boothInfo[0].Code">{{row.boothInfo[0].Code}}</span>
            </span>
            <span v-else></span>
          </template>

          <template slot-scope="{ row }" slot="show">
            <iSwitch v-model="row.exIsShow" @on-change="showToggle(row)" />
          </template>

          <template slot-scope="{ row }" slot="prize">
            <a href="javascript:;" @click="setPrize(row)">奖项设置</a>
          </template>

          <template slot-scope="{ row }" slot="toTop">
            <a href="javascript:;" @click="setToTop(row)">设置</a>
          </template>

          <template slot-scope="{ row }" slot="top">
            <a href="javascript:;" @click="setTopic(row)">设置</a>
          </template>

          <template slot-scope="{ row }" slot="brand">
            <a href="javascript:;" @click="setBrand(row)">设置</a>
          </template>

          <template slot-scope="{ row }" slot="edit">
            <a href="javascript:;" @click="$router.push('/host/index/ex/editEx?id=' + row.compId)">查看</a> |
            <!-- <a href="javascript:;" @click="$router.push('/host/index/ex/proList?id=' + row.compId)">展品</a> |
            <a href="javascript:;" @click="$router.push('/host/index/ex/act?id=' + row.compId)">活动</a> | -->
            <a href="javascript:;" @click="resetPwd(row)">重置密码</a> 
            <!-- | -->
            <!-- <Poptip
              confirm
              title="确认发送短信?"
              @on-ok="sendMsg(row.id)" 
              placement="left"
            >
              <a href="javascript:;">短信</a>
            </Poptip>|-->
            <!-- <Poptip confirm title="确认删除吗?" @on-ok="del(row.id)" placement="left">
              <a href="javascript:;">删除</a>
            </Poptip> -->
          </template>
        </Table>
        <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px;text-align: center;">
          <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
    <!-- 修改展商置顶 -->

    <exToTop :show="editToTop" v-if="editToTop" @finish="init()" :editInfo="editToTopInfo" @close="editToTop=false;editToTopInfo=null;" />
    <exTopic :show="editTopic" v-if="editTopic" @finish="init()" :editTopicnfo="editTopicnfo" @close="editTopic=false;editTopicnfo=null;" />
    <exBrand :show="editBrand" v-if="editBrand" @finish="init()" :editBrandnfo="editBrandnfo" @close="editBrand=false;editBrandnfo=null;" />
    <exPrize :show="editPrize" v-if="editPrize" @finish="init()" :editPrizeInfo="editPrizeInfo" @close="editPrize=false;editPrizeInfo=null;" />

    <iModal v-model="resetShow" title="重置密码" class-name="resetModal" :closable="false">
      <Form ref="formReset2" :model="formReset2" :rules="ruleReset2" inline :label-width="120">
        <FormItem label="新密码：" prop="newPhone">
          <Input type="text" style="width:300px;" v-model="formReset2.newPhone" placeholder="请输入新密码" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="cancel2">取消</Button>
        <Button type="primary" @click="reset2('formReset2')">确认</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import exBrand from "./subpages/ex-brand.vue";
import exTopic from "./subpages/ex-topic.vue";
import exToTop from "./subpages/ex-to-top.vue";
import exPrize from "./subpages/ex-prize.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "host-ex-list",
  data () {
    return {
      resetShow: false,
      resetInfo: {},
      formReset2: {
        newPhone: "",
      },
      ruleReset2: {
        newPhone: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          {
            type: "string",
            min: 4,
            message: "密码不能小于4位",
            trigger: "blur",
          },
          {
            type: "string",
            max: 50,
            message: "密码不能大于50位",
            trigger: "blur",
          },
        ],
      },
      editBrand: false,
      editBrandnfo: null,
      editPrize: false,
      editPrizeInfo: null,
      editTopic: false,
      editTopicnfo: null,
      editToTop: false,
      editToTopInfo: null,
      search: "",
      editInfo: null,
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        // {
        //   title: "logo",
        //   slot: "logo",
        //   align: "center",
        //   width: 150,
        // },
        {
          title: "公司名称",
          slot: "name",
          align: "center",
          width: 240,
        },
        // {
        //   title: "展品类别",
        //   slot: "categories",
        //   align: "center",
        //   width: 240,
        // },
        // {
        //   title: "奖项",
        //   slot: "prizeLabel",
        //   align: "center",
        // },
        {
          title: "展位",
          slot: "address",
          align: "center",
        },
        {
          title: "业务员",
          slot: "exOperator",
          align: "center",
        },
        // {
        //   title: "显示状态",
        //   slot: "show",
        //   align: "center",
        //   width: 100,
        // },
        // {
        //   title: "奖项设置",
        //   slot: "prize",
        //   align: "center",
        // },
        // {
        //   title: "置顶",
        //   slot: "toTop",
        //   align: "center",
        //   width: 100,
        // },
        // {
        //   title: "推荐",
        //   slot: "top",
        //   align: "center",
        //   width: 100,
        // },
        // {
        //   title: "品牌推荐",
        //   slot: "brand",
        //   align: "center",
        //   width: 100,
        // },
        // {
        //   title: "业务员",
        //   slot: "brand",
        //   align: "center",
        //   width: 100,
        // },
        {
          title: "操作",
          slot: "edit",
          align: "center",
          width: 250,
        },
      ],
      list: [],
      selection: [], // 选中项目
    };
  },
  components: {
    exTopic,
    exBrand,
    exToTop,
    exPrize,
  },
  computed: {
    ...mapGetters({
      hostExhibitionId: "hostSetModule/getHostExhibitionId",
    }),
    option () {
      return {
        ExhibitionId: this.exhibitionInfo.id,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 1,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "Name",
                  Value: `%${this.search}%`,
                },
              },
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "prizeLabel",
                  Value: `%${this.search}%`,
                },
              },
            ],
          },
        },
      };
    },
    exhibitionInfo () {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  created () {
    this.init();
  },
  methods: {
    ...mapActions({
      syncArrHandle: "hostSetModule/syncArrHandle",
      editCompanyShow: "hostSetModule/editCompanyShow",
      getCompanyByJoin: "hostSetModule/getCompanyByJoin",
      delCompanyById: "hostSetModule/delCompanyById",
      editCompanyInfo: "hostSetModule/editCompanyInfo",
      editExPwd: "hostSetModule/editExPwd",
    }),
    async reset2 (name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        CompId: this.resetInfo.compId,
        JoinId: this.resetInfo.joinId,
        NewPassword: this.formReset2.newPhone,
      };

      let bool = await this.editExPwd(req);
      if (bool && bool.successed) {
        this.$Message.success("修改成功！");
        this.init();
        this.cancel2();
      } else {
        if (bool.errors[0].description) {
          this.$Message.warning(bool.errors[0].description);
        } else {
          this.$Message.warning("修改失败，请重试！");
        }
      }
    },
    cancel2 () {
      this.resetShow = false;
      this.resetInfo = {};
      (this.formReset2.newPhone = ""), this.$refs.formReset2.resetFields();
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    async init () {
      let proData = await this.getCompanyByJoin(this.option);
      if (proData) {
        proData.items.map((c) => {
          if (c.categories) {
            c.categories = JSON.parse(c.categories);
          } else {
            c.categories = [];
          }
          if (c.boothInfo) {
            c.boothInfo = JSON.parse(c.boothInfo);
          } else {
            c.boothInfo = [];
          }
        });
        this.list = proData.items;
        console.log("list:", this.list);
        this.pageSize = proData.pageSize;
        this.pageIndex = proData.pageIndex;
        this.totalCount = proData.totalCount;
      }
    },
    async del (id) {
      const bool = await this.delCompanyById(id);
      if (bool && bool.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    setAllShow () {
      const reqList = [];
      if (!this.selection.length) return;
      this.selection.forEach((c) => {
        const req = this.editCompanyShow({ JoinId: c.joinId, IsShow: true });
        reqList.push(req);
      });
      Promise.all(reqList).then((res) => {
        if (res && res[0] && res[0].successed) {
          this.$Message.success("修改成功");
          this.$refs.selection.selectAll(false);
          this.init();
        } else {
          this.$Message.error("修改失败，请重新尝试");
        }
      });
    },
    setAllHide () {
      const reqList = [];
      if (!this.selection.length) return;
      this.selection.forEach((c) => {
        const req = this.editCompanyShow({ JoinId: c.joinId, IsShow: false });
        reqList.push(req);
      });
      Promise.all(reqList).then((res) => {
        if (res && res[0] && res[0].successed) {
          this.$Message.success("修改成功");
          this.$refs.selection.selectAll(false);
          this.init();
        } else {
          this.$Message.error("修改失败，请重新尝试");
        }
      });
    },
    setAllDel () {
      const reqList = [];
      if (!this.selection.length) return;
      this.selection.forEach((c) => {
        const req = this.delCompanyById(c.compId);
        reqList.push(req);
      });
      Promise.all(reqList).then((res) => {
        if (res && res[0] && res[0].successed) {
          this.$Message.success("删除成功");
          this.$refs.selection.selectAll(false);
          this.init();
        } else {
          this.$Message.error("删除失败，请重新尝试");
        }
      });
    },
    changePage (e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize (e) {
      this.pageSize = e;
      this.init();
    },
    // 修改展品显示、屏蔽
    async showToggle (item) {
      const bool = !!item.exIsShow;
      let result = await this.editCompanyShow({
        JoinId: item.joinId,
        IsShow: bool,
      });
      if (result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    setPrize (item) {
      // 设置置顶
      this.editPrizeInfo = item;
      this.editPrize = true;
    },
    setTopic (item) {
      // 设置置顶
      this.editTopicnfo = item;
      this.editTopic = true;
    },
    setToTop (item) {
      this.editToTopInfo = item;
      this.editToTop = true;
    },
    setBrand (item) {
      // 设置品牌
      this.editBrandnfo = item;
      this.editBrand = true;
    },
    edit (item) {
      this.editInfo = item;
    },
    sendMsg () { },
    searchPro () {
      this.pageIndex = 1;
      this.init();
    },
    changeEvent (selection) {
      // 选中
      this.selection = selection;
    },
    resetPwd (e) {
      this.resetShow = true;
      this.resetInfo = e;
    },
    async syncHandle () {
      if (!this.hostExhibitionId) return;
      let bool = await this.syncArrHandle(this.hostExhibitionId);
      if (bool && bool.successed) {
        this.$Message.success("同步成功！");
      } else {
        if (bool.msg) {
          this.$Message.warning(bool.msg);
        } else {
          this.$Message.warning("操作失败，请重试！");
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;
  button {
    margin-right: 20px;
  }
}
.logo {
  width: 60px;
  height: 60px;
  display: inline-block;
}
/deep/ .resetModal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
  .ivu-modal-body {
    padding: 24px 0 0 16px;
  }
}
</style>

